import { useState } from "react";
import ContactSearchList from "./ContactSearchList/ContactSearchList";
import ContactTable from "./ContactTable/ContactTable";
import { tw } from "@careinfo/tailwind";

const Contact = (props: any) => {
  const { data } = props;

  const [selectedGroupId, setSelectedGroupId] = useState<any>({
    is_default: data?.[0]?.is_default,
    id: data?.[0]?.id,
  });

  return (
    <>
      <div className={tw`flex gap-4`}>
        <ContactSearchList
          selectedGroupId={selectedGroupId}
          setSelectedGroupId={setSelectedGroupId}
        />
        <ContactTable selectedGroupId={selectedGroupId} />
      </div>
    </>
  );
};

export default Contact;
